/**
 * Wishlist Stock Control
 * Tüm sayfalarda sepete ekleme işlemlerinde stok kontrolü yapar
 * Wishlist, Search, Product ve diğer tüm sayfalarda çalışır
 */

(function() {
    'use strict';
  
    const pathname = window.location.pathname;
  
    // RTL/Arapça desteği için dil kontrolü
    const htmlLang = document.documentElement.lang || '';
    const isArabic = htmlLang.startsWith('ar') || document.documentElement.dir === 'rtl';
    const toastPosition = isArabic ? 'left' : 'right';
  
    console.log('🛒 Stock control: Script initialized on:', pathname, '| RTL:', isArabic);
  
    // XMLHttpRequest'i de intercept et (wishlist app belki bunu kullanıyordur)
    const originalXHROpen = XMLHttpRequest.prototype.open;
    const originalXHRSend = XMLHttpRequest.prototype.send;
  
    XMLHttpRequest.prototype.open = function(method, url, ...rest) {
      this._url = url;
      this._method = method;
      return originalXHROpen.call(this, method, url, ...rest);
    };
  
    function buildWkVariantCache(data) {
      if (!data) {
        window._wkVariantIds = new Set();
        return;
      }
      const items = data.items || data.wishlist?.items || [];
      window._wkVariantIds = new Set(
        Array.isArray(items) ? items.map(i => Number(i.variantId || i.variant_id)).filter(Boolean) : []
      );
      console.log('🛒 Wishlist: _wkVariantIds cache built, size:', window._wkVariantIds.size);
    }

    XMLHttpRequest.prototype.send = function(body) {
      if (this._url && typeof this._url === 'string' && this._url.includes('/wishlists/mine') &&
          this._method && this._method.toUpperCase() === 'GET') {
        this.addEventListener('load', function() {
          if (this.status === 200) {
            try { buildWkVariantCache(JSON.parse(this.responseText)); } catch (e) {}
          }
        });
      }

      if (this._url && typeof this._url === 'string' && this._url.includes('/cart/add')) {
        console.log('🛒 XHR: Intercepting cart/add request');
  
        this.addEventListener('load', function() {
          if (this.status >= 400) {
            console.error('🛒 XHR: Cart add error', this.status, this.responseText);
  
            try {
              const errorData = JSON.parse(this.responseText);
              const errorMsg = errorData?.description || errorData?.message || window.themeTranslations?.addToCartError || 'Could not add to cart';
  
              // Toast mesajı göster
              if (window.Toastify) {
                setTimeout(() => {
                  Toastify({
                    text: `<img src="https://cdn.shopify.com/s/files/1/0646/0833/8075/files/allert.svg?v=1733225445" class="toastify-icon" width="20px" /> ${errorMsg}`,
                    duration: 3000,
                    className: 'stock-alert-container',
                    style: {
                      background: "#000",
                      color: "#fff",
                    },
                    escapeMarkup: false,
                    newWindow: true,
                    close: false,
                    gravity: "top",
                    position: toastPosition,
                    stopOnFocus: true,
                    onClick: function () { }
                  }).showToast();
                }, 100);
              }
  
              // Cart notification'ı kapat
              const cartNotification = document.querySelector('cart-notification');
              if (cartNotification) {
                setTimeout(() => {
                  if (cartNotification.classList.contains('active')) {
                    cartNotification.classList.remove('active');
                  }
                }, 150);
              }
            } catch (e) {
              console.error('🛒 XHR: Error parsing response:', e);
            }
          }
        });
      }
  
      return originalXHRSend.call(this, body);
    };
  
    // Fetch API'yi de intercept et
    const originalFetch = window.fetch;
    const pendingCartAddVariantIds = new Set();

    function getCartAddItems(options) {
      const body = options?.body;
      if (!body) return [];

      let payload = body;
      if (body instanceof FormData || body instanceof URLSearchParams) {
        payload = { id: body.get('id') };
      } else if (typeof body === 'string') {
        try {
          payload = JSON.parse(body);
        } catch (e) {
          payload = Object.fromEntries(new URLSearchParams(body));
        }
      }

      const items = Array.isArray(payload?.items) ? payload.items : [payload];
      return items.map(item => ({
        id: String(item?.id || ''),
        quantity: Math.max(1, parseInt(item?.quantity, 10) || 1)
      })).filter(item => item.id);
    }

    function getTrackedInventory(variantId) {
      const values = Array.from(document.querySelectorAll('[data-variant-id="' + variantId + '"][data-inventory]'))
        .map(element => parseInt(element.dataset.inventory, 10))
        .filter(value => Number.isFinite(value) && value >= 0 && value < 999999);
      return values.length ? Math.max(...values) : null;
    }

    function isCartAddWithinInventory(items) {
      const trackedItems = items
        .map(item => ({ ...item, inventory: getTrackedInventory(item.id) }))
        .filter(item => item.inventory !== null);
      if (!trackedItems.length) return Promise.resolve(true);

      return originalFetch('/cart.js', {
        headers: { 'Accept': 'application/json' },
        cache: 'no-store'
      })
        .then(response => response.json())
        .then(cart => trackedItems.every(item => {
          const quantityInCart = (cart.items || []).reduce((total, cartItem) =>
            String(cartItem.variant_id || cartItem.id) === item.id
              ? total + (Number(cartItem.quantity) || 0)
              : total, 0);
          return quantityInCart + item.quantity <= item.inventory;
        }))
        /* Stok kontrol istegi gecici olarak basarisizsa Shopify cevabi son
           guvenlik katmani olmaya devam etsin; sepete eklemeyi kilitleme. */
        .catch(() => true);
    }

    function buildPendingAddResponse() {
      const message = window.themeTranslations?.stockLimitReached ||
        window.themeTranslations?.addToCartError ||
        'Please wait for the current cart update.';
      return new Response(JSON.stringify({
        status: 422,
        __stockBlocked: true,
        description: message,
        message: message
      }), {
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      });
    }

    window.fetch = function(...args) {
      const input = args[0];
      const options = args[1];
      const url = typeof input === 'string' ? input : (input instanceof Request ? input.url : (input?.url || String(input || '')));
      const method = (options?.method || (input instanceof Request ? input.method : 'GET') || 'GET').toUpperCase();

      // WishlistKing GET — build _wkVariantIds cache (also intercepted via XHR above)
      if (url && typeof url === 'string' && url.includes('/wishlists/mine') && method === 'GET') {
        return originalFetch.apply(this, args).then(response => {
          try {
            response.clone().json().then(buildWkVariantCache).catch(() => {});
          } catch (e) {}
          return response;
        });
      }

      // Eğer cart/add.js isteğiyse
      if (url && typeof url === 'string' && (url.includes('/cart/add.js') || url.includes('/cart/add'))) {
        /* Ayni varyant icin paralel add.js istekleri Shopify stok kontrolunu
           ayni anda gecebilir. Varyant bazli kilit, spam tiklamalarindan yalnizca
           ilkini sunucuya yollar; farkli varyantlar paralel kalmaya devam eder. */
        const addItems = getCartAddItems(options);
        const variantIds = [...new Set(addItems.map(item => item.id))];
        if (variantIds.some(id => pendingCartAddVariantIds.has(id))) {
          window.__wishlistPreBlocked = true;
          return Promise.resolve(buildPendingAddResponse());
        }

        variantIds.forEach(id => pendingCartAddVariantIds.add(id));
        window.__wishlistPreBlocked = false;
        /* Client-side stok ön-kontrolü kaldırıldı: her /cart/add öncesi seri bir
           /cart.js isteği atıp cevabı bekliyordu (sepete ekleme = 2 round-trip).
           Shopify /cart/add.js zaten stok aşımında 422 + açıklama dönüyor ve
           aşağıdaki `!response.ok` dalı bunu zaten kullanıcıya gösteriyor.
           (getTrackedInventory / isCartAddWithinInventory artık kullanılmıyor.) */
        return originalFetch.apply(this, args).then(response => {
          if (!response.ok) {
            response.clone().json().then(errorData => {
              const isPDP = window.location.pathname.match(/\/products\/[^/]+$/);
              if (isPDP) return;
              const errorMsg = errorData?.description || errorData?.message || window.themeTranslations?.addToCartError || 'Could not add to cart';
              if (window.Toastify) {
                Toastify({
                  text: `<img src="https://cdn.shopify.com/s/files/1/0646/0833/8075/files/allert.svg?v=1733225445" class="toastify-icon" width="20px" /> ${errorMsg}`,
                  duration: 3000,
                  className: 'stock-alert-container',
                  style: { background: '#000', color: '#fff' },
                  escapeMarkup: false,
                  newWindow: true,
                  close: false,
                  gravity: 'top',
                  position: toastPosition,
                  stopOnFocus: true
                }).showToast();
              }
            }).catch(() => {});
          }
          return response;
        }).finally(() => {
          variantIds.forEach(id => pendingCartAddVariantIds.delete(id));
        });
      }

      // Diğer istekler için normal fetch
      return originalFetch.apply(this, args);
    };
  
    console.log('🛒 Wishlist: Fetch & XHR interceptors installed');
  
  })();
